import ReactGA from "react-ga4";
import {
  Fade,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import ThreeSixtyImage from "../components/ThreeSixtyImage";

function ThreeSixty() {


  const poses = { 'kneeling1': "Kneeling Pose 1", 'sitting': "Sitting Pose 1" };
  const angles = { 'front': "Front", 'top': "Top", 'top3q': "Top 3 Quarters" };

  const [currentPose, setCurrentPose] = useState("sitting");
  const [currentAngle, setCurrentAngle] = useState("top3q");
  const [currentModel, setCurrentModel] = useState("malemuscle");

  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/threesixty", page_title: '360 Viewer'});
  }, [])

  return (
    <>
    <ThreeSixtyImage
          currentPose={currentPose}
          currentAngle={currentAngle}
        />
        <Fade in={true} timeout={500}>
          
      <Stack direction="column" spacing={4}>
      <p style={{ textAlign:'center' }}>Use the arrow keys or drag the image to move around</p>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: '', sm: 'center' }} justifyContent="center" pb={4}>
          <FormControl>
            <InputLabel id="poseSelector">Select Pose</InputLabel>
            <Select
              labelId="poseSelector"
              value={currentPose}
              label="Select Pose"
              onChange={(e) => {
                setCurrentPose(e.target.value);
              }}
            >
              {Object.keys(poses).map((key, index) => {
                return <MenuItem key={key} value={key}>{poses[key]}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel id="angleSelector">Select Angle</InputLabel>
            <Select
              labelId="angleSelector"
              value={currentAngle}
              label="Select Angle"
              onChange={(e) => {
                setCurrentAngle(e.target.value);
              }}
            >
              {Object.keys(angles).map((key, index) => {
                return <MenuItem key={key} value={key}>{angles[key]}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel id="modelSelector">Select Model</InputLabel>
            <Select
              labelId="modelSelector"
              value={currentModel}
              label="Select Model"
              onChange={(e) => {
                setCurrentAngle(e.target.value);
              }}
            >
              <MenuItem key='malemuscle' value='malemuscle'>Male Muscle</MenuItem>
            
            </Select>
          </FormControl>
        </Stack>
        
      </Stack>
    </Fade>
    </>
  );
}

export default ThreeSixty;
